export * from "./filter-chip.component";
